export default function SRoute({ size = 20, color="currentColor", className = "", ...props }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path d="M8.57881 7.36109L10.1523 8.96192C10.0018 8.93455 9.85127 8.92087 9.68708 8.89351C9.52289 8.86614 9.34502 8.86614 9.15347 8.86614C8.41463 8.86614 7.68946 8.9756 6.9643 9.19452C6.22546 9.41344 5.5687 9.79654 4.99405 10.3028V3.80368L6.59488 5.40452L7.99047 3.98155L3.98155 0L0 3.98155L1.3956 5.37715L2.99643 3.80368V17.9102H4.98036V13.9286C5.28138 12.8751 5.81499 12.0815 6.56751 11.5752C7.32004 11.0553 8.15466 10.809 9.04401 10.809C9.22188 10.809 9.39975 10.809 9.59131 10.8501C9.76918 10.8774 9.94705 10.9048 10.1386 10.9322L8.56513 12.533L9.96073 13.9286H10.0018L13.9833 9.96073L10.0018 5.97917L8.61986 7.37477L8.57881 7.36109Z"
            fill={color}/>
    </svg>
  )
}